
import { Tabs, Button } from "antd";

import AppLayout from "../../components/Layout";
import { PhonebookTable } from "../../components/Dashboards/Tables/PhonebookTable";
import { SolveesyDiallerTable } from "./SolveesyDiallerTable";

const SolveesyDialler = () => {
  const items = [
    {
      label: "Phonebook",
      key: "1",
      children: <SolveesyDiallerTable  />,
    },
  ];

  return (

      <Tabs items={items}></Tabs>
  
  );
};

export default SolveesyDialler;
